<template>
  <div
    class="category-item relative my-2"
    :class="{
      'is-dragging': isDragging,
      'is-drag-over': isDragOver
    }"
    tabindex="0"
    @keydown.up.prevent="moveUp"
    @keydown.down.prevent="moveDown"
    :draggable="isAdmin"
    @dragstart="handleDragStart"
    @dragend="handleDragEnd"
    @dragover.prevent="handleDragOver"
    @dragleave="handleDragLeave"
    @contextmenu.prevent="handleContextMenu"
  >
    <router-link
      :to="category.toState"
      class="flex justify-between items-center p-2 m-0 text-sm font-medium leading-4 rounded-lg text-slate-700 dark:text-slate-100 hover:bg-slate-25 dark:hover:bg-slate-800"
      :class="computedClass"
    >
      <div>
        <span>{{ category.icon }}</span>
        <span class="truncate">{{ category.name }}</span>
      </div>
      <span
        v-if="showChildCount(category.count)"
        class="px-1 py-0 mx-1 font-medium rounded-md text-xxs"
        :class="{
          'text-slate-300 dark:text-slate-600': isCountZero && !isActiveView,
          'text-slate-600 dark:text-slate-50': !isCountZero && !isActiveView,
          'bg-woot-75 dark:bg-woot-200 text-woot-600 dark:text-woot-600':
            isActiveView,
          'bg-slate-50 dark:bg-slate-700': !isActiveView,
        }"
      >
        {{ `${category.count}` }}
      </span>
    </router-link>
  </div>
</template>

<script>
import { frontendURL } from 'dashboard/helper/URLHelper';
import adminMixin from 'dashboard/mixins/isAdmin';

export default {
  mixins: [adminMixin],
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isDragging: false,
      isDragOver: false
    };
  },
  computed: {
    isCountZero() {
      return this.category.count === 0;
    },
    isActiveView() {
      return this.computedClass.includes('active-view');
    },
    itemRoute() {
      const { accountId } = this.$store.getters.getCurrentAccount;
      const portalSlug = this.$route.params.portalSlug;
      const locale = this.$route.params.locale;
      
      return frontendURL(`accounts/${accountId}/portals/${portalSlug}/${locale}/categories/${this.category.id}`);
    },
    computedClass() {
      // If active inbox is present, do not highlight conversations
      if (this.activeInbox) return ' ';
      if (
        this.isAllConversations ||
        this.isMentions ||
        this.isUnattended ||
        this.isCurrentRoute
      ) {
        return 'bg-woot-25 dark:bg-slate-800 text-woot-500 dark:text-woot-500 hover:text-woot-500 dark:hover:text-woot-500 active-view';
      }
      if (this.hasSubMenu) {
        if (
          this.isBrandsSettings ||
          this.isTeamsSettings ||
          this.isInboxSettings ||
          this.isIntegrationsSettings ||
          this.isApplicationsSettings
        ) {
          return 'bg-woot-25 dark:bg-slate-800 text-woot-500 dark:text-woot-500 hover:text-woot-500 dark:hover:text-woot-500 active-view';
        }
        return 'hover:text-slate-700 dark:hover:text-slate-100';
      }

      return 'hover:text-slate-700 dark:hover:text-slate-100';
    },
  },
  methods: {
    handleDragStart(e) {
      if (!this.isAdmin) return;
      
      this.isDragging = true;
      e.dataTransfer.setData('text/plain', JSON.stringify({
        type: 'category',
        id: this.category.id,
        position: this.category.position
      }));
    },
    handleContextMenu(event) {
      this.$emit('show-context-menu', {
        event,
        category: this.category
      });
    },
    handleDragEnd() {
      this.isDragging = false;
    },
    handleDragOver() {
      this.isDragOver = true;
    },
    handleDragLeave() {
      this.isDragOver = false;
    },
    showChildCount(count) {
      return Number.isInteger(count);
    },
  }
};
</script>


<style lang="scss" scoped>
.menu-list-move {
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.category-item {
  transition: transform 0.3s ease, opacity 0.2s ease;
  
  &.is-dragging {
    @apply shadow-lg scale-[0.98] rotate-1;
    opacity: 0.7;
  }
  
  &.is-drag-over {
    &::before {
      content: '';
      @apply absolute w-full h-1 bg-woot-500 rounded;
      animation: dropIndicator 0.3s ease-in-out;
    }
  }
}

/* Add this new section */
.menu-list-move {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-list-enter-active,
.menu-list-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-list-enter-from,
.menu-list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

@keyframes dropIndicator {
  from { transform: scaleX(0); }
  to { transform: scaleX(1); }
}

@keyframes slideIn {
  from {
    transform: translateX(-50%) scaleX(0);
  }
  to {
    transform: translateX(-50%) scaleX(10);
  }
}
</style>